<template>
  <div>
    <div class="main-title">用车记录</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-select
              v-model="searchForm.company_ids"
              multiple
              placeholder="选择科目"
              @change="search(searchParams)"
              style="width:250px;">
              <el-option
                v-for="item in companyList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="searchForm.daterange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :disabled="user.buttons.indexOf(1020) < 0"
              :picker-options="datePickerOptions"
              @change="search(searchParams)">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索车牌号或编号"
              v-model="searchForm.query"
              prefix-icon="el-icon-search"
              clearable
              @input="inputSearch(searchParams)">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索备注"
              v-model="searchForm.remark"
              prefix-icon="el-icon-search"
              clearable
              @input="inputSearch(searchParams)"
              style="width: 130px"
            >
            </el-input>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
          <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
          <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <el-table
        :data="list"
        stripe
        border
        :height="tableHeight"
        style="width:100%">
        <el-table-column
          prop="company_name"
          label="所属科目"
          width="100">
        </el-table-column>
        <el-table-column
          prop="car_alias"
          label="车辆编号"
          width="90">
        </el-table-column>
        <el-table-column
          prop="licnum"
          label="车牌号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="use_type"
          label="用车类型"
          width="90"
          :filters="typeFilters"
          :filter-method="filterTypes"
          filter-placement="bottom-end">
        </el-table-column>
        <el-table-column
          label="地图轨迹"
          width="80">
          <template slot-scope="scope">
            <el-button type="text" @click="showTrack(scope.row.id)">地图轨迹</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="secu_name"
          label="安全员"
          width="80">
        </el-table-column>
        <el-table-column
          prop="coach_name"
          label="用车人"
          width="160">
        </el-table-column>
        <el-table-column
          prop="start_time"
          label="开始时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="end_time"
          label="结束时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="use_time"
          label="时长"
          width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.use_time">{{ scope.row.use_time }}分钟</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="oper_name"
          label="操作员"
          width="70">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          width="150">
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <track-dialog :visible="trackDialogVisible" :gpsdata="trackDialogGpsData" @close="trackDialogVisible = false"></track-dialog>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import DatePickerOptions from '../../mixins/DatePickerOptions'
import moment from 'moment'
import TrackDialog from './TrackDialog'
import offset from '../../assets/offset'
export default {
  mixins: [ListFunc, DatePickerOptions],
  components: {
    TrackDialog
  },
  data () {
    return {
      sqlcode: 'history_list',
      companyList: [],
      searchForm: {
        company_ids: [],
        query: '',
        remark: null,
        daterange: [
          this.user.buttons.indexOf(1020) < 0 ? new Date() : new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 30),
          new Date()
        ]
      },
      typeFilters: [
        { text: '训练', value: '训练' },
        { text: '考试', value: '考试' },
        { text: '牵车', value: '牵车' },
        { text: '试车', value: '试车' },
        { text: '热车', value: '热车' },
        { text: '加油', value: '加油' },
        { text: '维修', value: '维修' },
        { text: '洗车', value: '洗车' },
        { text: '培训', value: '培训' }
      ],
      trackDialogGpsData: [],
      trackDialogVisible: false
    }
  },
  computed: {
    searchParams () {
      if (!this.searchForm.daterange || this.searchForm.daterange.length === 0) {
        return this.searchForm
      } else {
        return {
          company_ids: this.searchForm.company_ids,
          query: this.searchForm.query,
          remark: this.searchForm.remark,
          daterange_start: moment(this.searchForm.daterange[0]).format('YYYY-MM-DD'),
          daterange_end: moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59'
        }
      }
    }
  },
  mounted () {
    this.fetchCompanyList()
  },
  methods: {
    filterTypes (value, row) {
      return row.status ===  value
    },
    fetchCompanyList () { // 获取考场列表
      this.$http.get('/dbapi/company_combo').then(response => {
        if (response.data.success) {
          this.companyList = response.data.list
          this.searchForm.company_ids = this.companyList.map(c => c.value)
        }
      })
    },
    showTrack (id) {
      this.trackDialogVisible = false
      this.trackDialogGpsData = []
      this.$http.get('/api/gpsdata?t=history&id=' + id).then(response => {
        if (response.data.success) {
          let list = response.data.list
          if (list.length === 0) {
            this.$alert('这段时间内没有GPS数据，请检查车载GPS设备是否正常', '提示', {
              confirmButtonText: '我知道了'
            })
          } else {
            for (var i = 0; i < list.length; i++) {
              list[i].lonlat = offset(parseFloat(list[i].lon), parseFloat(list[i].lat))
            }
            this.trackDialogGpsData = list
            this.trackDialogVisible = true
          }
        } else {
          this.$alert(response.data.message, '提示', {
            confirmButtonText: '我知道了'
          })
        }
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/rent/History.vue